import React from 'react';
import { useParams } from 'react-router-dom';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';
import WhatsAppShareButton from '../Components/WhatsAppShareButton';

const AnnouncementDetails = () => {
  const { Id } = useParams();
  const distID = localStorage.getItem('distributorId');
  const boostID = localStorage.getItem('companyIdBooster');
  const parisID = localStorage.getItem('companyIdParis');

  const { data, error, isLoaded } = GetRequest(`/Scheme/GetAnnouncementDetails/${distID}/${Id}`);

  if (error) return <Error data="Something went wrong!" />;
  if (!isLoaded) return <Loading />;

  const announcement = data.result;

  if (!announcement) {
    return <Error data="Announcement not found." />;
  }

  return (
    <section className="content">
      <div className="container py-4">
        <div className="card shadow border-0">
          <div className="card-body">
            {/* Title */}
            <h2 className="text-success fw-bold mb-3">{announcement.title}</h2>

            {/* Dates */}
            <p className="text-muted mb-4">
              {announcement.announcementStartDateTime && (
                <>
                  <strong>Start:</strong> {new Date(announcement.announcementStartDateTime).toLocaleString()}
                </>
              )}
              {announcement.announcementExpiryDateTime && (
                <>
                  &nbsp;|&nbsp;
                  <strong>Ends:</strong> {new Date(announcement.announcementExpiryDateTime).toLocaleString()}
                </>
              )}
            </p>

            {/* Image */}
            {announcement.image && (
              <div className="my-4 text-center">
                <img
                  src={announcement.image}
                  alt="Announcement"
                  className="img-fluid rounded shadow-sm"
                  style={{ maxHeight: '400px', objectFit: 'contain' }}
                />
              </div>
            )}

            {/* Description */}
            {announcement.description && (
              <div
                className="mt-3 text-dark"
                dangerouslySetInnerHTML={{ __html: announcement.description }}
              />
            )}

            {/* Links Section */}
            <div className="mt-4">
              {announcement.documentUrl && (
                <p>
                  📄 <a href={announcement.documentUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">View Document</a>
                </p>
              )}

              {announcement.externalUrl && (
                <p>
                  🌐 <a href={announcement.externalUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">Visit External Site</a>
                </p>
              )}

              {announcement.appUrl && (
                <p>
                  📱 <a href={announcement.appUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-underline">Open in App</a>
                </p>
              )}
            </div>

            {/* WhatsApp Share */}
            <div className="mt-4">
              <WhatsAppShareButton
                message={`📢 ${announcement.title}\n\nCheck it out here: ${announcement.externalUrl || window.location.href}`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnnouncementDetails;